/*
 * @Author: zhang lin
 * @Date: 2022-04-07 11:03:35
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-04-04 18:29:05
 * @Description: file content
 */
import { combineReducers } from 'redux';
import installReducer from 'root/store/Install/reducer';
import diskReducer from 'root/store/disk/reducer';
import fileConfigReducer from './fileConfig/reducer';
import syncBackReducer from './syncBack/reducer';
import nanotubeReducer from './nanotube/reducer';

import packManageReducer from 'root/pages/PackageManage/store/reducer'; // 安装包管理
import uploadFileReducer from 'root/components/UploadFile/store/reducer'; //  安装包上传
import envManageReducer from 'root/pages/EnvManage/store/reducer'; // 运行环境管理
import nodeConfigReducer from 'root/store/nodeConfig/reducer'; // 安装页面节点管理  安装页面多租户
import tenantReducer from 'root/store/tenant/reducer'; // 安装页面多租户

import { SERVER_STATUS, SYS_STATUS, UPDATE_ENV, UPDATES_DIR } from './constant';

export interface commonStates {
  sysStatus: string; // 平台状态
  serverStatus: string; // 服务器状态
  sereverInfo: any; // 服务器信息,
  partionInfo: any; // 分区信息
  createSuccess?: boolean; // 从非标进行分区并且成功
  notInstalled?: boolean; // 是否未未安装supos
  status?: any; // 所有产品信息
  noSupos?: boolean; // 未安装supos 用于判断系统监控和备份还原菜单是否可以用
  hasEnv?: boolean; // 是否有运行环境
  hasSuposCatalogue: boolean; // 是否有supos/home目录
}

const defaultStates: commonStates = {
  sysStatus: '',
  serverStatus: 'init',
  sereverInfo: {},
  partionInfo: {},
  createSuccess: false,
  notInstalled: false,
  status: [],
  noSupos: false,
  hasEnv: false,
  hasSuposCatalogue: false,
};

const common = (state: commonStates = defaultStates, action: any) => {
  switch (action.type) {
    case SERVER_STATUS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case SYS_STATUS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case UPDATE_ENV: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case UPDATES_DIR: {
      return {
        ...state,
        ...action.payload,
      };
    }

    default:
      return state;
  }
};

const reducer = combineReducers({
  common,
  install: installReducer,
  disk: diskReducer,
  fileConfig: fileConfigReducer,
  syncBack: syncBackReducer,
  packManage: packManageReducer,
  uploadFile: uploadFileReducer,
  envManage: envManageReducer,
  nodeConfig: nodeConfigReducer,
  nanotubeConfig: nanotubeReducer,
  tenant: tenantReducer,
});

export default reducer;
